import axios from 'axios';
import router from '@/router';

// API базовий URL з змінної середовища або значення за замовчуванням
// Для зміни URL створіть .env.local файл з VUE_APP_API_URL=http://your-backend-url:port
// У production використовується nginx proxy через /api
const getApiBaseURL = () => {
  // Перевіряємо, чи є змінна середовища і чи вона не порожня
  const envUrl = process.env.VUE_APP_API_URL;
  if (envUrl && envUrl.trim() !== '') {
    return envUrl.trim();
  }
  
  // У production використовуємо nginx proxy через /api
  if (process.env.NODE_ENV === 'production') {
    return `${window.location.origin}/api`;
  }
  
  // Локальна розробка
  return 'http://localhost:4443';
};

const apiBaseURL = getApiBaseURL();

// Діагностичне логування (тільки в development)
if (process.env.NODE_ENV !== 'production') {
  console.log('API Configuration:');
  console.log('  NODE_ENV:', process.env.NODE_ENV);
  console.log('  VUE_APP_API_URL:', process.env.VUE_APP_API_URL || '(not set)');
  console.log('  Final API Base URL:', apiBaseURL);
}

const api = axios.create({
  baseURL: apiBaseURL,
  timeout: 5000,
});

// Перехоплювач для запитів
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Перехоплювач для відповідей
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Діагностичне логування помилок
    if (error.response) {
      console.error('API Error Response:', {
        status: error.response.status,
        statusText: error.response.statusText,
        data: error.response.data,
        url: error.config?.url,
      });
    } else if (error.request) {
      console.error('API Error Request:', {
        message: 'No response received',
        url: error.config?.url,
      });
    } else {
      console.error('API Error:', error.message);
    }
    
    if (error.response && error.response.status === 401) {
      // Токен недійсний або закінчився
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      router.push('/login'); // Перенаправлення на логін
    }
    return Promise.reject(error);
  }
);

export default api;
